import { Component, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gift-cards-banner-receipt',
  templateUrl: './gift-cards-banner-receipt.component.html',
  styleUrls: ['./gift-cards-banner-receipt.component.scss']
})
export class GiftCardsBannerReceiptComponent implements OnInit {
  @Output() onReadMore = new EventEmitter<void>();

  constructor() {
  }

  ngOnInit() {
  }

}
